import React from 'react';
import TabPageContainer from '~components/atoms/TabPageContainer';
import InventoryDeliveredTable from './InventoryDeliveredTable';
import InventoryDeliveredPaginator from './InventoryDeliveredPaginator';

const InventoryDelivered = () => {
    return (
        <TabPageContainer>
            <InventoryDeliveredTable />
            <InventoryDeliveredPaginator />
        </TabPageContainer>
    );
};

export default InventoryDelivered;
